import {Component} from "@angular/core";

@Component({
    selector: "fui-chrome-actions",
    styleUrls: ["./chrome-actions.component.scss"],
    templateUrl: "./chrome-actions.component.html",
    standalone: false
})
export class FUIChromeActionsComponent {
}
